interface MetricDeltaProps {
  label: string;
  current: number;
  original?: number;
  format?: "percent" | "ratio" | "currency";
  higherIsBetter?: boolean;
}

export default function MetricDelta({
  label,
  current,
  original,
  format = "percent",
  higherIsBetter = true,
}: MetricDeltaProps) {
  const formatValue = (v: number) => {
    switch (format) {
      case "percent":
        return `${v >= 0 ? "+" : ""}${v.toFixed(1)}%`;
      case "ratio":
        return v.toFixed(2);
      case "currency":
        return `$${v.toLocaleString()}`;
      default:
        return v.toFixed(2);
    }
  };

  const delta = original !== undefined ? current - original : undefined;
  const isImproved =
    delta !== undefined
      ? higherIsBetter
        ? delta > 0
        : delta < 0
      : undefined;

  return (
    <div className="text-center">
      <div
        className={`text-lg font-bold ${
          format === "percent"
            ? current >= 0
              ? "metric-value-positive"
              : "metric-value-negative"
            : "text-surface-200"
        }`}
      >
        {formatValue(current)}
      </div>
      <div className="text-xs text-surface-500 font-medium">{label}</div>
      {delta !== undefined && delta !== 0 && (
        <div
          className={`text-xs mt-0.5 ${
            isImproved ? "text-green-400" : "text-red-400"
          }`}
        >
          {isImproved ? "▲" : "▼"} {delta > 0 ? "+" : ""}
          {delta.toFixed(1)}
        </div>
      )}
    </div>
  );
}
